import { CachedSamplingConfig } from './cached-sampling-config';

export const cache: CachedSamplingConfig = new CachedSamplingConfig();
